import { render, staticRenderFns } from "./DateProgressbar.vue?vue&type=template&id=04525582&scoped=true&lang=pug&"
import script from "./DateProgressbar.vue?vue&type=script&lang=js&"
export * from "./DateProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./DateProgressbar.vue?vue&type=style&index=0&id=04525582&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04525582",
  null
  
)

export default component.exports